module.exports = __webpack_public_path__ + "static/media/art-sample-6.1c6bc3fe.png";